﻿import { LiveDataSet } from "../API/LiveData/LiveDataSet";
import { deleteParamterGroupSettings, getAllParamterGroupSettings, setParamterGroupSettings } from "../API/ParameterGroupsSettings/ParamterGroupsSettings";
import { RESTError } from "../API/RESTError";
import { ParameterSchemaSensor } from "../API/Schema/ParameterSchema";
import { IHashData } from "../IHashData";
import { IPage } from "../IPage";
import { MainSite } from "../MainSite";
import { ParameterGroupSettings } from "../Model/ParameterGroupSettings";
import { IRegion, IStationsByRegion } from "../Model/Region";

export class ManageParameterGroupSettingsPage implements IPage {
    constructor(private mainSite: MainSite) {
    }

    public id: string = 'manageParameterGroupsSettings';

    public initialize(): void {
    }

    protected hasLiveData: boolean = false;

    private container: JQuery = null;
    private loadingContainer: JQuery = null;
    private table: JQuery = null;
    private tableBody: JQuery = null;
    private tableHead: JQuery = null;
    private tableHeadRow: JQuery = null;    
    private modal: JQuery = null;

    protected modalBodyContent: JQuery;
    protected modalFieldStationId: JQuery;
    protected modalFieldParameterGroup: JQuery;
    protected modalFieldSensor: JQuery;
    protected modalFieldMasked: JQuery;
    protected modalSaveButton: JQuery;
    protected modalDeleteButton: JQuery;

    protected data: ParameterGroupSettings[];


    public handleHashChange(hashData: IHashData): boolean {
        if (hashData.Page === this.id) {
            if (!this.container) {
                this.refresh();
            }
            return true;
        } else {
            if (this.modal) {
                this.modal.modal('hide');
                $('body').removeClass('modal-open');
                $('.modal-backdrop').remove();
                this.modal.remove();
                this.modal = null;
            }
            if (this.container) {
                this.container.remove();
                this.container = null;
            }
            return false;
        }
    }

    private refresh(): void {
        if (this.container) {
            this.container.remove();
            this.container = null;
        }

        this.container = $('<div class="container"></div>').appendTo('body');
        this.loadingContainer = $('<div class="alert alert-info"><i class="fa fa-lg fa-fw fa-refresh fa-spin"></i> Loading...</div>').appendTo(this.container);

        /*
        this.mainSite.staticDataManager.getStaticData((err) => {
            this.data = this.mainSite.staticDataManager.Schema.ParameterGroupSettings;
            if (this.mainSite.liveDataManager.latestData == null) {
                this.mainSite.liveDataManager.addListener(this);
            } else {
                this.hasLiveData = true;
                this.render();
            }
        });
        */

        getAllParamterGroupSettings((err: RESTError, data) => {
            if (err) {
                this.loadingContainer.removeClass('alert-info').addClass('alert-danger').html('<i class="fa fa-lg fa-fw fa-warning"></i> Uable to get list of settings from server: ' + err.Message);
            } else {
                this.loadingContainer.removeClass('alert-danger').addClass('alert-info').html('<i class="fa fa-lg fa-fw fa-refresh fa-spin"></i> Loading...');
            }

            this.data = data;

            if (this.mainSite.liveDataManager.latestData == null) {
                this.mainSite.liveDataManager.addListener(this);
            } else {
                this.hasLiveData = true;
                this.render();
            }
        });
    }

    public liveDataChanged(latestData: LiveDataSet): void {
        if (!this.hasLiveData && latestData !== null) {
            this.hasLiveData = true;
            this.render();
        }
    }

    private render(): void {
        /* //: NB: container is being rendered in this.refresh(), to allow adding a loading indicator, as it can take a few seconds for the api/Schema/Get request to complete, and we're also waiting for LiveData to be updated with initial data.
        if (this.container) {
            this.container.remove();
            this.container = null;
        }

        this.container = $('<div class="container"></div>').appendTo('body');
        */

        $('<h1 class="midi_manageUsersPage_title">Manage Parameter Groups Settings</h1>').appendTo(this.container);
        $('<button type="button" class="btn btn-success midi_manageUsersPage_createUserButton"><i class="fa fa-plus"></i> Add Settings</button>')
            .appendTo(this.container)
            .click(() => {
                this.renderModalEdit(null);
            });

        if (this.mainSite.currentUser.Permissions.GlobalAdministrator) {
            $('<p class="midi_manageUsersPage_topParagraph">As a <strong>Global Administrator</strong>, you can  manage Parameter Group Settings across all regions.</p>').appendTo(this.container);
        } else {
            var region: IRegion = this.mainSite.staticDataManager.Schema.RegionSet.Regions[this.mainSite.currentUser.Region];
            $('<p class="midi_manageUsersPage_topParagraph">As a <strong>Regional Administrator</strong> for the <strong>' + region.Label + '</strong> region, you can manage Parameter Group Settings for sites within your region.</p>').appendTo(this.container);
        }

        this.table = $('<table class="table table-striped table-hover midi_common_table"></table>').appendTo(this.container);
        this.tableBody = $('<tbody></tbody>').appendTo(this.table);
        this.tableHead = $('<thead></thead>').appendTo(this.table);
        this.tableHeadRow = $('<tr></tr>').appendTo(this.tableHead);
        $('<th>Station</th> <th>Sensor</th> <th>Parameter Group</th> <th class="text-center">Masked</th>').appendTo(this.tableHeadRow);

        let _page: ManageParameterGroupSettingsPage = this;
        this.data.forEach(x => {
            var tableCurrentRow = $('<tr></tr>').appendTo(_page.tableBody);
            tableCurrentRow.data('paramGroupSettings', x);

            $('<td></td>').attr("data-field", "StationId").text(_page.mainSite.staticDataManager.Schema.ParameterSchema.Stations[x.StationId].Station.Label).appendTo(tableCurrentRow);
            $('<td></td>').attr("data-field", "Sensor").text(x.Sensor).appendTo(tableCurrentRow);
            $('<td></td>').attr("data-field", "ParameterGroup").text(x.ParameterGroup).appendTo(tableCurrentRow);
            $('<td></td>').attr("data-field", "Masked").addClass('text-center').html(x.Masked ? '<i class="fa fa-lg fa-fw fa-check"></i>' : '<i class="fa fa-lg fa-fw fa-times"></i>').appendTo(tableCurrentRow);

            tableCurrentRow.css({ 'cursor': 'pointer' }).on("click", (e) => {
                _page.renderModalEdit(tableCurrentRow);
            });
        });

        this.setNoRowsMessage(this.tableBody, 4);

        $('[data-toggle="tooltip"]').tooltip();
        this.loadingContainer.hide();
    }

    private setNoRowsMessage($tableBody: JQuery, colsCount: number = 4): void {
        $tableBody.find('tr.no-rows-message-row').remove();
        if ($tableBody.find('tr:not(.no-rows-message-row)').length == 0) {
            let $row: JQuery = $('<tr>').addClass('no-rows-message-row').appendTo($tableBody);
            $(`<td colspan="${colsCount}" class="text-center text-muted"><div style="margin:40px 0;"><i class="fa fa-lg fa-info-circle"></i> There are no Parameter Group Settings yet.<br>Use the button above to add new Parameter Group Settings.</div></td>`).appendTo($row);
        }
    }

    private renderModalEdit(tableRow: JQuery = null) { // currentSetting: ParameterGroupSettings = null
        const currentSetting: ParameterGroupSettings = tableRow == null ? null : tableRow.data('paramGroupSettings');
        const StationsByRegion: IStationsByRegion[] = this.mainSite.getStationsByRegions();
        const addNew = currentSetting == null;

        let modalDataClone: ParameterGroupSettings = currentSetting !== null ? { ...currentSetting } : { StationId: '', Sensor: '', ParameterGroup: '', Masked: false }; //: use a clone or new object to help update data

        // console.log("renderModalEdit()", { new: addNew, currentSetting: currentSetting, row: tableRow, stations: StationsByRegion, schema: this.mainSite.staticDataManager.Schema });

        if (this.modal) {
            this.modal.remove();
            this.modal = null;
        }

        let _page: ManageParameterGroupSettingsPage = this;

        this.modal = $('<div class="modal fade"></div>').appendTo('body');
        let modalDialog: JQuery = $('<div class="modal-dialog"></div>').appendTo(this.modal);
        let modalContent: JQuery = $('<div class="modal-content"></div>').appendTo(modalDialog);

        //: Modal Header:
        let modalHeaderContent: JQuery = $('<div class="modal-header"></div>').appendTo(modalContent);
        $('<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>').appendTo(modalHeaderContent);
        if (addNew) {
            $('<h4 class="modal-title">Add Parameter Group Settings</h4>').appendTo(modalHeaderContent);
        } else {
            $('<h4 class="modal-title">Edit Parameter Group Settings</h4>').appendTo(modalHeaderContent);
        }

        //: Modal Content:
        this.modalBodyContent = $('<div class="modal-body"></div>').appendTo(modalContent);
        let modalFeedbackWrap: JQuery = $('<div class="modal-feedback"></div>').appendTo(this.modalBodyContent);

        //: Form wrapper:
        let modalForm: JQuery = $('<form></form>').appendTo(this.modalBodyContent);
        modalForm.addClass("form-horizontal");
        modalForm.on("submit", (e) => {
            return false;
        });

        //: Field: StationId
        const stationRow: JQuery = $('<div class="form-group"></div>').appendTo(modalForm);
        const stationLbl: JQuery = $('<label class="col-sm-3 control-label">Station:</label>').appendTo(stationRow);
        const stationCol: JQuery = $('<div class="col-sm-9"></div>').appendTo(stationRow);
        this.modalFieldStationId = $('<select class="form-control"></select>').appendTo(stationCol);

        if (addNew) {
            this.modalFieldStationId.append('<option value="" selected="selected" disabled>Please select a Station...</option>');
        }

        StationsByRegion.forEach(region => {
            let $optgroup: JQuery = $('<optgroup></optgroup>').attr("label", region.Region.Label);
            region.Stations.forEach(station => {
                let $opt: JQuery = $('<option value="' + station.Id + '">' + station.Label + '</option>');
                if (modalDataClone && modalDataClone !== null && modalDataClone.StationId == station.Id) {
                    $opt.prop("selected", true);
                }
                $opt.appendTo($optgroup);
            });

            $optgroup.appendTo(this.modalFieldStationId);
        });

        this.modalFieldStationId.on("change", (e) => {
            const _stationId: string = $(e.target).val();
            modalDataClone.StationId = _stationId;

            let _sensors: { [sensorId: string]: ParameterSchemaSensor } = {};

            if (_stationId && _stationId !== null && _stationId !== '') {
                _sensors = _page.mainSite.getStationSensors(_stationId);
            }

            // console.info("changed STATION: ", { id: _stationId, sensors: _sensors, paramgroups: null, modalData: modalDataClone, modalDataOriginal: currentSetting });

            this.modalFieldSensor.find('option').remove();
            let count: number = 0;
            for (let sensorId in _sensors) {
                let $opt: JQuery = $('<option value="' + sensorId + '">' + sensorId + '</option>');
                if (modalDataClone && modalDataClone !== null && modalDataClone.Sensor == sensorId) {
                    $opt.prop("selected", true);
                }
                $opt.appendTo(this.modalFieldSensor);
                count++;
            }

            if (count == 0 || modalDataClone.Sensor == '') {
                let $opt: JQuery = $('<option value="" selected="selected" disabled>Please select a Station, then a Sensor...</option>');
                $opt.prependTo(this.modalFieldSensor);
            }

            //: Trigger change on Sensor field to ensure that the list of Param Groups gets populated:
            this.modalFieldSensor.trigger("change");
        });



        //: Field: Sensor
        const sensorRow: JQuery = $('<div class="form-group"></div>').appendTo(modalForm);
        const sensorLbl: JQuery = $('<label class="col-sm-3 control-label">Sensor:</label>').appendTo(sensorRow);
        const sensorCol: JQuery = $('<div class="col-sm-9"></div>').appendTo(sensorRow);
        this.modalFieldSensor = $('<select class="form-control"></select>').appendTo(sensorCol);

        if (addNew) {
            this.modalFieldSensor.append('<option value="" selected="selected" disabled>Please select a Station, then a Sensor...</option>');
        }

        //: trigger onchange of station to populate list of sensors:
        this.modalFieldStationId.trigger("change");

        this.modalFieldSensor.on("change", (e) => {
            const _sensorId: string = $(e.target).val();
            modalDataClone.Sensor = _sensorId;

            let _paramGroups: string[] = [];

            if (_sensorId && _sensorId !== null && _sensorId !== '') {
                _paramGroups = _page.mainSite.getStationParameterGroups(modalDataClone.StationId, modalDataClone.Sensor);
            }

            // console.info("changed SENSOR: ", { id: _sensorId, sensors: null, paramgroups: _paramGroups, modalData: modalDataClone, modalDataOriginal: currentSetting });

            this.modalFieldParameterGroup.find('option').remove();
            let count: number = 0;
            for (let i in _paramGroups) {
                const paramGroup: string = _paramGroups[i];
                let $opt: JQuery = $('<option value="' + paramGroup + '">' + paramGroup + '</option>');
                if (modalDataClone && modalDataClone !== null && modalDataClone.ParameterGroup == paramGroup) {
                    $opt.prop("selected", true);
                }
                $opt.appendTo(this.modalFieldParameterGroup);
                count++;
            }

            if (count == 0 || modalDataClone.ParameterGroup == '') {
                let $opt: JQuery = $('<option value="" selected="selected" disabled>Please select a Sensor, then a Parameter Group...</option>');
                $opt.prependTo(this.modalFieldParameterGroup);
            }
        });



        //: Field: ParamterGroup
        const pgRow: JQuery = $('<div class="form-group"></div>').appendTo(modalForm);
        const pgLbl: JQuery = $('<label class="col-sm-3 control-label">Parameter Group:</label>').appendTo(pgRow);
        const pgCol: JQuery = $('<div class="col-sm-9"></div>').appendTo(pgRow);
        this.modalFieldParameterGroup = $('<select class="form-control"></select>').appendTo(pgCol);

        if (addNew) {
            this.modalFieldParameterGroup.append('<option value="" selected="selected" disabled>Please select a Sensor, then a Parameter Group...</option>');
        }

        //: trigger onchange of sensor to populate list of param groups:
        this.modalFieldSensor.trigger("change");

        this.modalFieldParameterGroup.on("change", (e) => {
            const _parameterGroup: string = $(e.target).val();
            modalDataClone.ParameterGroup = _parameterGroup;
        });



        //: Field(s): Settings:
        const settingsRow: JQuery = $('<div class="form-group"></div>').appendTo(modalForm);
        const settingsLbl: JQuery = $('<label class="col-sm-3 control-label">Settings:</label>').appendTo(settingsRow);
        const settingsCol: JQuery = $('<div class="col-sm-9"></div>').appendTo(settingsRow);

        const settingMaskedWrap: JQuery = $('<label></label>').appendTo($('<div class="checkbox"></div>').appendTo(settingsCol));
        this.modalFieldMasked = $('<input type="checkbox" />').appendTo(settingMaskedWrap);
        $('<span>Masked</span>').disableSelection().appendTo(settingMaskedWrap);
        this.modalFieldMasked.prop("checked", modalDataClone.Masked);

        // this.modalFieldMasked.on("change", (e) => { //: moved to being set in sumbit action..
        //     const _val: boolean = $(e.target).is(":checked");
        //     modalDataClone.Masked = _val;
        // });


        //: prevent PrimaryKey changes in case we're in edit mode:
        if (!addNew) {
            this.modalFieldStationId.prop("disabled", true);
            this.modalFieldSensor.prop("disabled", true);
            this.modalFieldParameterGroup.prop("disabled", true);
        }

        //: additional event handlers:
        modalForm.find(':input').on('change', (e) => {
            modalForm.find('.has-error, .has-warning, .midi_common_validation_warning').removeClass('has-error has-warning midi_common_validation_warning');
            modalFeedbackWrap.html('').hide();
            modalForm.addClass('data-changed');
            window.onbeforeunload = () => {
                return "You have unsaved modifications on this page. If you navigate away from the page, your modifications will not be saved.";
            };
        });


        //: Footer:
        let modalFooterContent: JQuery = $('<div class="modal-footer"></div>').appendTo(modalContent);
        this.modalSaveButton = $('<button type="button" class="btn btn-success">Save</button>')
            .appendTo(modalFooterContent)
            .click(() => {
                // console.info("save...", { old: currentSetting, new: modalDataClone });
                modalForm.find('.has-error, .has-warning, .midi_common_validation_warning').removeClass('has-error has-warning midi_common_validation_warning');
                modalFeedbackWrap.html('').hide();

                let errors: string[] = [];

                //: validations:
                if (modalDataClone.StationId == '' || modalDataClone.StationId == null) {
                    errors.push("Please select a Station.");
                    this.modalFieldStationId.addClass('midi_common_validation_warning').closest('.form-group').addClass('has-error');
                }
                if (modalDataClone.Sensor == '' || modalDataClone.Sensor == null) {
                    errors.push("Please select a Sensor.");
                    this.modalFieldSensor.addClass('midi_common_validation_warning').closest('.form-group').addClass('has-error');
                }
                if (modalDataClone.ParameterGroup == '' || modalDataClone.ParameterGroup == null) {
                    errors.push("Please select a Parameter Group.");
                    this.modalFieldParameterGroup.addClass('midi_common_validation_warning').closest('.form-group').addClass('has-error');
                }

                //: ensure we have values from the modal form:
                modalDataClone.Masked = this.modalFieldMasked.is(":checked");

                if (errors.length > 0) {
                    modalFeedbackWrap.html('<div class="alert alert-danger"><i class="fa fa-lg fa-warning"></i> <strong>Please correct the below errors:</strong><br><br>- ' + errors.join('<br>- ') + '</div>').show();
                    return false;
                }

                if (errors.length == 0) {
                    const req: ParameterGroupSettings = modalDataClone;
                    setParamterGroupSettings(req, (err: RESTError) => {
                        if (err) {
                            errors.push("Server error: " + err.Message);
                            modalFeedbackWrap.html('<div class="alert alert-danger"><i class="fa fa-lg fa-warning"></i> <strong>Unable to save your changes:</strong><br><br>- ' + errors.join('<br>- ') + '</div>').show();
                        }
                        modalForm.removeClass('data-changed');
                        this.modal.modal('hide');

                        if (addNew) {
                            this.refresh();
                        } else {
                            tableRow.data('paramGroupSettings', modalDataClone);
                            tableRow.find('td[data-field="Masked"]').html(modalDataClone.Masked ? '<i class="fa fa-lg fa-fw fa-check"></i>' : '<i class="fa fa-lg fa-fw fa-times"></i>');
                            tableRow.addClass("bg-success");
                            setTimeout(() => {
                                tableRow.removeClass("bg-success");
                            }, 3000);
                        }
                    });
                }
            });

        $('<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>').appendTo(modalFooterContent);

        if (!addNew) {
            this.modalDeleteButton = $('<button type="button" class="btn btn-danger pull-left">Delete these settings</button>')
                .prependTo(modalFooterContent)
                .click(() => {
                    modalForm.find('.has-error, .has-warning, .midi_common_validation_warning').removeClass('has-error has-warning midi_common_validation_warning');
                    modalFeedbackWrap.html('').hide();

                    let errors: string[] = [];

                    //: validations:
                    if (modalDataClone.StationId == '' || modalDataClone.StationId == null) {
                        errors.push("Please select a Station.");
                        this.modalFieldStationId.addClass('midi_common_validation_warning').closest('.form-group').addClass('has-error');
                    }
                    if (modalDataClone.Sensor == '' || modalDataClone.Sensor == null) {
                        errors.push("Please select a Sensor.");
                        this.modalFieldSensor.addClass('midi_common_validation_warning').closest('.form-group').addClass('has-error');
                    }
                    if (modalDataClone.ParameterGroup == '' || modalDataClone.ParameterGroup == null) {
                        errors.push("Please select a Parameter Group.");
                        this.modalFieldParameterGroup.addClass('midi_common_validation_warning').closest('.form-group').addClass('has-error');
                    }

                    if (errors.length > 0) {
                        modalFeedbackWrap.html('<div class="alert alert-danger"><i class="fa fa-lg fa-warning"></i> <strong>Please correct the below errors:</strong><br><br>- ' + errors.join('<br>- ') + '</div>').show();
                        return false;
                    }

                    if (errors.length == 0) {
                        let stationName: string = this.modalFieldStationId.find('option[value="' + modalDataClone.StationId + '"]').text();
                        let conf = confirm("Are you certain you wish to permanently delete the settings for " + stationName + " / " + modalDataClone.Sensor + " / " + modalDataClone.ParameterGroup + "?");
                        if (conf) {
                            deleteParamterGroupSettings(modalDataClone.StationId, modalDataClone.Sensor, modalDataClone.ParameterGroup, (err: RESTError) => {
                                if (err) {
                                    errors.push("Server error: " + err.Message);
                                    modalFeedbackWrap.html('<div class="alert alert-danger"><i class="fa fa-lg fa-warning"></i> <strong>Unable to save your changes:</strong><br><br>- ' + errors.join('<br>- ') + '</div>').show();
                                }
                                modalForm.removeClass('data-changed');
                                this.modal.modal('hide');
                                // this.refresh();
                                tableRow.data('paramGroupSettings', null);
                                tableRow.remove();
                                this.setNoRowsMessage(this.tableBody, 4);
                            });
                        }
                    }
                });
        }

        this.modal.modal('show');

        this.modal.on('hide.bs.modal', (e) => {
            if (modalForm.hasClass('data-changed')) {
                let conf = confirm("You have unsaved changes on this popup.\n\nAre you sure you wish to cancel and close the popup?");
                if (!conf) {
                    return false;
                }
            }
        });

        this.modal.on('hidden.bs.modal', (e) => {
            this.modal.remove();
            this.modal = null;
            window.onbeforeunload = null;
        });
    }
}